import React from 'react';
import Loader from '@appComponents/Loader/Loader';
import IOnlyLoggedIn from './IOnlyLoggedIn';

export default function onlyLoggedInHOC<OriginalProps>(WrappedComponent: React.ComponentClass<OriginalProps>) {
  return class OnlyLoggedIn extends React.Component<OriginalProps & IOnlyLoggedIn> {
    render() {
      return this.props.userInfo
        ? <WrappedComponent {...this.props} />
        : (
          <div className="redirect">
            <Loader moreSpace={true} />
            {window.location.replace(`/users/sign_in?return_url=${window.location.pathname}`)}
          </div>
        );
    }
  };
}
